import { useAuth } from "context/AuthContext";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import constants from "config/constants";

function AcuityScheduling() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const location = useLocation();
  const userSubmissionId = location.state?.userSubmissionId;
  const [isScheduled, setIsScheduled] = useState(false);

  const {
    ownerId: ACUITY_OWNER_ID,
    baseUrl: ACUITY_BASE_URL,
    userSubmissionFieldId: ACUITY_USER_SUBMISSION_FIELD_ID,
    embedScriptUrl: ACUITY_EMBED_SCRIPT_URL,
  } = constants.acuity;

  // Listen to Acuity postMessage events to detect when appointment is booked
  useEffect(() => {
    const handleMessage = (event) => {
      try {
        const data =
          typeof event.data === "string"
            ? event.data
            : JSON.stringify(event.data);

        if (
          data &&
          (data.includes("ACUITY_APPOINTMENT_SCHEDULED") ||
            data.includes("acuity_appointment_scheduled") ||
            data.includes("action=scheduled") ||
            data.includes("action=confirmed") ||
            data.includes('"action":"scheduled"') ||
            data.includes('"event":"scheduled"') ||
            data.includes("appointment-scheduled"))
        ) {
          setIsScheduled(true);
        } else if (
          typeof event.data === "string" &&
          event.data.startsWith("sizing:")
        ) {
          const height = parseInt(event.data.replace("sizing:", ""), 10);
          // Calendar & time picker view has height > 1150px
          if (height > 1150) {
            setIsScheduled(false);
          }
        }
      } catch (err) {
        // ignore unparseable messages
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = ACUITY_EMBED_SCRIPT_URL || "https://embed.acuityscheduling.com/js/embed.js";
    script.type = "text/javascript";
    document.body.appendChild(script);
    return () => {
      if (script.parentNode) script.remove();
    };
  }, [ACUITY_EMBED_SCRIPT_URL]);

  const [firstName, ...lastParts] = (user?.name || "").split(" ");
  const lastName = lastParts.join(" ");

  const schedulerUrl = new URL(ACUITY_BASE_URL);
  schedulerUrl.searchParams.set("owner", ACUITY_OWNER_ID);
  schedulerUrl.searchParams.set("ref", "embedded_csp");
  schedulerUrl.searchParams.set("firstName", firstName);
  schedulerUrl.searchParams.set("lastName", lastName);
  schedulerUrl.searchParams.set("email", user?.email);
  schedulerUrl.searchParams.set("userSubmissionId", userSubmissionId);

  if (userSubmissionId) {
    schedulerUrl.searchParams.set(
      `field:${ACUITY_USER_SUBMISSION_FIELD_ID}`,
      userSubmissionId
    );
  }

  return (
    <div style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          flexWrap: "wrap",
          gap: "12px",
        }}
      >
        <h1 style={{ margin: 0, fontSize: "28px" }}>Schedule Your Appointment</h1>
        {isScheduled && (
          <button
            type="button"
            onClick={() => navigate("/", { replace: true })}
            style={{
              backgroundColor: "#112314",
              color: "#ffffff",
              padding: "8px 18px",
              borderRadius: "24px",
              border: "1px solid rgba(255, 195, 246, 0.3)",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              boxShadow: "0 4px 12px rgba(17, 35, 20, 0.2)",
              transition: "all 0.2s ease",
            }}
          >
            <span>Back to Home</span>
          </button>
        )}
      </div>

      <div
        style={{
          marginBottom: "24px",
          padding: "16px",
          backgroundColor: "#f8faf8",
          borderRadius: "8px",
          borderLeft: "4px solid #4CAF50",
          fontSize: "14px",
          color: "#1f2937",
        }}
      >
        <p style={{ margin: "0 0 8px 0" }}>
          By scheduling an appointment, you agree to our{" "}
          <a
            href="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#112314",
              fontWeight: "600",
              textDecoration: "none",
              borderBottom: "1px solid #112314",
            }}
          >
            Privacy Policy
          </a>
        </p>
      </div>
      <iframe
        src={schedulerUrl.toString()}
        title="Schedule Appointment"
        width="100%"
        height="800"
        frameBorder="0"
        allow="payment"
        style={{ display: "block", width: "100%", minHeight: "800px", border: "none" }}
      />
    </div>
  );
}

export default AcuityScheduling;
